import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetCurrentUserData } from '../store/current-user/current-user.state';

export const userDataResolver = () => {
  const store = inject(Store);
  return store.dispatch(new GetCurrentUserData());
};
